import {
  type ClockDirection,
  type ClockState,
} from '@/features/courts/clock/model';
import { useClock } from '@/features/courts/clock/use-clock';
import { cn } from '@/utils/cn';
import { formatTime } from '@/utils/time';

const SIZES = {
  display: 'text-[45vh] leading-none',
  overlay: 'text-4xl font-semibold',
  control: 'text-4xl font-bold',
} as const;

export const ClockFace = ({
  clock,
  direction,
  variant,
  className,
}: {
  clock: ClockState;
  direction: ClockDirection;
  variant: keyof typeof SIZES;
  className?: string;
}) => {
  const seconds = useClock(clock, direction);

  return (
    <div className={cn('text-center', SIZES[variant], className)}>
      {formatTime(seconds)}
    </div>
  );
};
